import GuideSearchResultItem from './GuideSearchResultItem';

export default GuideSearchResultItem;
